// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__2SbPd","main":"Sidebar_main__VKMC6","head":"Sidebar_head__E5GCg","header":"Sidebar_header__yGgid","body":"Sidebar_body__b9Sgj"};